import React from 'react';

const LayoutFooter = () => {
  return (
    <footer className="bg-gray-800 text-white p-8 mt-12">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4">Atlantis Fish</h3>
          <p className="text-gray-400">Tu destino para todo lo relacionado con la acuariofilia.</p>
        </div>
        <div>
          <h3 className="text-xl font-bold mb-4">Enlaces Rápidos</h3>
          <ul className="space-y-2">
            <li><button className="text-gray-400 hover:text-white transition-colors">Inicio</button></li>
            <li><button className="text-gray-400 hover:text-white transition-colors">Tienda</button></li>
            <li><button className="text-gray-400 hover:text-white transition-colors">Nosotros</button></li>
            <li><button className="text-gray-400 hover:text-white transition-colors">Contacto</button></li>
          </ul>
        </div>
        <div>
          <h3 className="text-xl font-bold mb-4">Contacto</h3>
          <p className="text-gray-400">Email: info@atlantisfish.com</p>
          <p className="text-gray-400">Teléfono: +57 301 3346595</p>
        </div>
      </div>
      <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-500">
        © 2025 Atlantis Fish. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default LayoutFooter;